import { V2StaticLegislationBriefing } from '../../components/static-legislation-briefing/V2StaticLegislationBriefing'
import { V2ProductRegulationPageShell } from './V2ProductRegulationPageShell'

type V2ProductRedRegulationPageProps = {
  productId: string
}

export function V2ProductRedRegulationPage({
  productId,
}: V2ProductRedRegulationPageProps) {
  return (
    <V2ProductRegulationPageShell productId={productId} law="red">
      {(applies) => <V2StaticLegislationBriefing law="red" applies={applies} />}
    </V2ProductRegulationPageShell>
  )
}
